import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CircleBtn, PopUpContainer } from "assets/css/globle";
import ActiveCircleIcon from "assets/svgIcons/ActiveCircleIcon";
import ActiveText from "assets/svgIcons/ActiveTextIcon";
import EditIcon from "assets/svgIcons/EditIcon";
import GridIcon from "assets/svgIcons/GridIcon";
import MeasurementIcon from "assets/svgIcons/MeasurementIcon";
import RefreshIcon from "assets/svgIcons/ResendIcon";
import AdminIcon from "assets/svgIcons/AdminIcon";

import Chip from "@mui/material/Chip";
import EzlocatorIcon from "assets/images/ezLocator_logo.png";
import EzlocatorButtonIcon from "assets/images/ezLocator.png";
import EzlocatorLinkIcon from "assets/svgIcons/EzlocatorLinkIcon";
import {
  getFeatureSetOption,
  getFeaturesList,
  isUserBasic,
  isUserReadOnly,
  isUserAdmin,
  isUserSupport,
  featureKey
} from "../../../constant";
import {
  BodySection,
  Container,
  Header,
  RefreshBtn,
} from "pages/Pins/PinPlacement/PinsPlacementStyled";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import {
  setGridsViewReduxStateAction,
  setViewMeasurementReduxStateAction,
  setViewDistanceYardsAction,
  setViewMeasureFromReduxStateAction,
  setActiveOnlyReduxStateAction,
  setAppDataReduxStateAction,
  setPrintDataReduxStateAction,
} from "redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";
import DoneIcon from "@mui/icons-material/Done";
import {
  setSelectedMeasurementPinReduxStateAction,
  setMeasurementPinStatus,
  setSelectedMeasurementPinBackupReduxStateAction,
} from "redux/reduxToolkitServices/_commonReducers/persistedSessionStorageReducer";
import {
  COMMON_SERVICES,
  headersConfigData,
} from "redux/reduxToolkitServices/_commonServices/commonServices";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import ListSubheader from "@mui/material/ListSubheader";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Modal from "@mui/material/Modal";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { Tooltip } from "@mui/material";
import { logAction, saveCourseRotationSets } from "../utils/helpers";
import Closest from "../../../assets/images/subSidenav/PinsImages/Closest.svg";
import Center from "../../../assets/images/subSidenav/PinsImages/Center.svg";
import FrontClosest from "../../../assets/images/subSidenav/PinsImages/FrontClosest.svg";
import FrontLeft from "../../../assets/images/subSidenav/PinsImages/FrontLeft.svg";
import { Loader } from "commonComponents/Loader/Loader";
import { uuid } from "../../../_helperFunctions/uuid";
import { PinSheetComponent } from "./pinSheet";
import { useLocation } from "react-router-dom";
import "./pin-placement.css";
import {
  carPinPlacementStateDataAction,
  carPinPlacementStateStatusAction,
  setPinsEditModeReduxStateAction,
  setPinsAdminModeReduxStateAction,
} from "redux/reduxToolkitServices/_commonReducers/commonReducers";
import { useCallback } from "react";
import Canvas from "./Canvas";
import {
  GlobalCourseIdState,
  PINS_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { useHookstate } from "@hookstate/core";
import { API_CALLS } from "redux/reduxToolkitServices/_commonApiCalls/api";
import { API_STATUSES } from "redux/_helpers/statuses";

const ButtonHandlerComponent = React.memo(({ saveCourseRotationSets, setDiscardPopUp, discardPopUp }) => {
    const dispatch = useDispatch();

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const { setDisplayButton, setdisabledEditButton, showCourseModal } = useHookstate(PINS_GLOBAL_STATE);

    const { siteSettingsData } = useSelector((state) => state.commonReducers) || [];

    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
      if(Object.keys(siteSettingsData).length > 0) {
        if(siteSettingsData?.Features?.indexOf(featureKey.golf) <= 0) {
          navigate("/dashboard", { replace: true });
        }
      }
    }, [siteId.get(), siteSettingsData]);

    useEffect(() => {
      if (PINS_GLOBAL_STATE.setDisplayButton.get()) {
        buttonEnabler();
      }
    }, [
      PINS_GLOBAL_STATE.setDisplayButton.get(),
      PINS_GLOBAL_STATE.setdisabledEditButton.get(),
    ]);

    const buttonEnabler = useCallback(() => {
      setDisplayButton.set(true);
      setdisabledEditButton.set(true);
      showCourseModal.set(true);
    }, [setDisplayButton.get()]);

    const discardPopUpHandler = useCallback(() => {
      setDiscardPopUp(true);
    }, [discardPopUp]);

    return (
      <div>
        {setDisplayButton.get() ? (
          <>
            <CircleBtn className="btn" onClick={discardPopUpHandler}>
              {t("Cancel")}
            </CircleBtn>
            <CircleBtn
              className="save-btn"
              onClick={() => {
                saveCourseRotationSets();
                dispatch(setPinsEditModeReduxStateAction(false));
                PINS_GLOBAL_STATE.setdisabledEditButton.set(false);
                PINS_GLOBAL_STATE.setDisplayButton.set(false);
                PINS_GLOBAL_STATE.showCourseModal.set(false);
                window.pinMovementDetectorReduxState = false;
              }}
            >
              {t("Save")}
            </CircleBtn>
          </>
        ) : (
          <></>
        )}
      </div>
    );
  }
);

export const TestingPins = React.memo(() => {
  const { t } = useTranslation();
  const childFunc = useRef(null);
  const location = useLocation();
  const printComponentRef = useRef(null);
  const colorPrintComponentRef = useRef(null);
  const { globalCourseId } = useHookstate(GlobalCourseIdState);
  const [rotationValues] = useState("");
  const [markerDataValue, setMarkerDataValue] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [rotationName, setRotationName] = useState("");
  const [discardPopUp, setDiscardPopUp] = useState(false);
  const [discardPopUp2, setDiscardPopUp2] = useState(false);
  const [EZlocatorModal, setEZlocatorModal] = useState(false);
  const [courseNumberGetter, setCourseNumberGetter] = useState(null);
  const [courseLabelGetter, setCourseLabelGetter] = useState(null);
  const [ezLocatorState, setEZLocatorState] = useState(false);
  const [updatedCourses, setUpdatedCourses] = useState([]);

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const dispatch = useDispatch();

  const {
    getUserRole,
    siteSettingsData,
    greensWithPinPlacementStateData,
    greensWithPinPlacementStateStatus,
    pinsEditModeReduxState,
    pinsAdminModeReduxState,
    selectedInitialPinsReduxData,
    updatePinRotationStateDataStatus,
    greensWithPinPlacementInfoStateData: {
      dailyRotationSets,
      specialRotationSets,
    } = {},
  } = useSelector((state) => state.commonReducers) || [];

  const {
    viewGridsReduxState,
    viewMeasurementReduxState,
    viewDistanceYardsReduxState,
    viewMeasureFromReduxState,
    activeOnlyReduxState,
    appDataReduxState: {
      courseNumber: courseNumberData,
      coursesData,
      siteName,
      courseName,
    } = {},
    printDataReduxState: { rotationName: rotationNameValue } = {},
  } = useSelector((state) => state.firstReducer);

  const { carPinPlacementStateData, carPinPlacementDataUpdated } = useSelector(
    (state) => state.commonReducers
  );
  const [courseNumber, setCourseNumber] = useState(Number(localStorage.getItem("courseId"))?Number(localStorage.getItem("courseId")):courseNumberData);

  const {
    selectedMeasurementPinReduxState,
    selectedMeasurementPinBackupReduxState,
  } = useSelector((state) => state.secondReduces);

  const handleClick = () => {
    dispatch(setViewMeasurementReduxStateAction(!viewMeasurementReduxState));
  };

  useEffect(() => {
    if (updatePinRotationStateDataStatus !== "idle") {
      dispatch(
        COMMON_SERVICES.getGreensWithPinPlacementsServices(siteId.get())
      );
    }
  }, [updatePinRotationStateDataStatus]);

  useEffect(() => {
    if (
      greensWithPinPlacementStateData &&
      greensWithPinPlacementStateData.EzLocatorCourse
    ) {
      setEZLocatorState(true);
      dispatch(setGridsViewReduxStateAction(false));
    } else {
      dispatch(setGridsViewReduxStateAction(true));
      setEZLocatorState(false);
    }
  }, [greensWithPinPlacementStateData]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getCarPinPlacementsServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    window.onload = window.pinMovementDetectorReduxState = false;
  }, []);

  useEffect(() => {
    if (siteId.get() !== null) {
      setUpdatedCourses([]);
    }
  }, [siteId.get()]);

  useEffect(() => {
    if (coursesData && coursesData?.length) {
      let tempData = coursesData.map((data) => {
        return {
          Number: data?.Number,
          updatedEzLocator: false,
          CreationDateInUtc: data?.CreationDateInUtc,
        };
      });
      setUpdatedCourses(tempData);
      setCourseNumber(coursesData.length<courseNumber? courseNumberData :courseNumber);
      localStorage.setItem("courseId", coursesData.length<courseNumber? courseNumberData : courseNumber);
      setCourseNumberGetter(coursesData.length<courseNumber? courseNumberData :courseNumber);
    }
  }, [coursesData]);

  useEffect(() => {
    dispatch(setSelectedMeasurementPinReduxStateAction("cog"));
    dispatch(setSelectedMeasurementPinBackupReduxStateAction("cog"));
    dispatch(COMMON_SERVICES.getGreensWithPinPlacementsServices(siteId.get()));
  }, [siteId.get(), courseNumber]);

  useEffect(() => {
    if (location.state === "color" && greensWithPinPlacementStateStatus === "success") {
      handlePrintColor();
    }
  }, []);

  const handleCourseName = (e) => {
    let index = e.nativeEvent.target.selectedIndex;
    let label = e.nativeEvent.target[index].text;
    let courseValue = Number(e.target.value);
    localStorage.setItem("courseId", Number(e.target.value));
    globalCourseId.set(Number(e.target.value));
    if (PINS_GLOBAL_STATE.showCourseModal.get()) {
      setCourseNumberGetter(courseValue);
      setCourseLabelGetter(label);
      setDiscardPopUp2(true);
    } else {
      setCourseNumber(courseValue);
      dispatch(
        setAppDataReduxStateAction({
          parameterDetector: "coursenumber",
          value: courseValue,
        })
      );
      dispatch(
        setAppDataReduxStateAction({
          parameterDetector: "coursename",
          value: label,
        })
      );
      dispatch(setPinsEditModeReduxStateAction(false));
    }
  };

  const handleRotations = useCallback(
    (e) => {
      let data = e.target.value.split(",");
      let markerValue = data[0];
      let rotationNameValue = data[1];
      setShowModal(true);
      setMarkerDataValue(markerValue);
      setRotationName(rotationNameValue);
    },
    [PINS_GLOBAL_STATE.showCourseModal.get()]
  );

  const handleGrids = useCallback(() => {
    dispatch(setGridsViewReduxStateAction(!viewGridsReduxState));
  }, [viewGridsReduxState]);

  const refreshData = useCallback(() => {
    dispatch(COMMON_SERVICES.getGreensWithPinPlacementsServices(siteId.get()));
  }, [siteId.get(), courseNumber]);

  const handleModalButtons = (buttonResponse) => {
    if (buttonResponse === "yes") {
      dispatch(setSelectedMeasurementPinReduxStateAction(markerDataValue));
      dispatch(
        setSelectedMeasurementPinBackupReduxStateAction(markerDataValue)
      );
      dispatch(
        setPrintDataReduxStateAction({
          parameterDetector: "rotationName",
          value: rotationName,
        })
      );
      logAction("Change active rotation to " + markerDataValue);
      setShowModal(false);
      PINS_GLOBAL_STATE.setdisabledEditButton.set(true);
      PINS_GLOBAL_STATE.setDisplayButton.set(true);
      dispatch(setPinsEditModeReduxStateAction(true));
      PINS_GLOBAL_STATE.showCourseModal.set(true);
    } else {
      setShowModal(false);
    }
  };

  const calculateDimension = (dimension) => {
    if (dimension === "yards") {
      dispatch(setViewDistanceYardsAction(true));
    } else {
      dispatch(setViewDistanceYardsAction(false));
    }
  };

  const getPinsDistance = (pinsDistance) => {
    if (pinsDistance === "front-closest") {
      dispatch(setViewMeasureFromReduxStateAction(pinsDistance));
    } else if (pinsDistance === "closest") {
      dispatch(setViewMeasureFromReduxStateAction(pinsDistance));
    } else if (pinsDistance === "front-left") {
      dispatch(setViewMeasureFromReduxStateAction(pinsDistance));
    } else {
      dispatch(setViewMeasureFromReduxStateAction(pinsDistance));
    }
  };

  const showActivePins = () => {
    dispatch(setActiveOnlyReduxStateAction(!activeOnlyReduxState));
    dispatch(setViewMeasurementReduxStateAction(false));
  };

  const handlePrintBlack = useReactToPrint({
    content: () => printComponentRef.current,
    removeAfterPrint: true,
  });

  const handlePrintColor = useReactToPrint({
    content: () => colorPrintComponentRef.current,
  });

  const handlePrintPreview = (e) => {
    let value = e.target.value;
    if (value === "color") {
      handlePrintColor();
    } else {
      handlePrintBlack();
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
      width: "calc(100% - 40px)",
      bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };

  const showPopupBox = () => {
    return (
      <Modal
        open={showModal}
        onClose={() => setShowModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirmation")}</h2>

            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {t("Make_this_the_active_Rotation_Set?")}
            </Typography>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button
                onClick={() => handleModalButtons("yes")}
                className="primary"
              >
                {t("Yes")}
              </button>
              <button onClick={() => handleModalButtons("no")}>
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  // This handler handle save rotation modal
  const rerenderData = () => {
    dispatch(
      setSelectedMeasurementPinReduxStateAction(selectedInitialPinsReduxData)
    );
    dispatch(
      setSelectedMeasurementPinBackupReduxStateAction(
        selectedInitialPinsReduxData
      )
    );
    dispatch(setPinsEditModeReduxStateAction(false));
    setDiscardPopUp(false);
    PINS_GLOBAL_STATE.setDisplayButton.set(false);
    PINS_GLOBAL_STATE.setdisabledEditButton.set(false);
    PINS_GLOBAL_STATE.showCourseModal.set(false);
    sessionStorage.removeItem("pinMovementDetectorReduxState");
    window.pinMovementDetectorReduxState = false;
  };

  const showDiscardBox = () => {
    return (
      <Modal
        open={discardPopUp}
        onClose={() => setDiscardPopUp(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {t("Discard_changes")}?
            </Typography>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button onClick={() => rerenderData()} className="primary">
                {t("Yes")}
              </button>
              <button onClick={() => setDiscardPopUp(false)}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  // This handler handle course handler
  const rerenderData2 = () => {
    if (courseNumberGetter && courseLabelGetter) {
      dispatch(
        setAppDataReduxStateAction({
          parameterDetector: "coursenumber",
          value: courseNumberGetter,
        })
      );
      dispatch(
        setAppDataReduxStateAction({
          parameterDetector: "coursename",
          value: courseLabelGetter,
        })
      );
      setCourseNumber(courseNumberGetter);
      dispatch(setPinsEditModeReduxStateAction(false));
      setDiscardPopUp2(false);
      PINS_GLOBAL_STATE.setDisplayButton.set(false);
      PINS_GLOBAL_STATE.showCourseModal.set(false);
      PINS_GLOBAL_STATE.setdisabledEditButton.set(false);
    }
  };

  const handleMeasurement = (e) => {
    if (viewMeasurementReduxState) {
      dispatch(setSelectedMeasurementPinReduxStateAction(e.target.value));
      dispatch(setMeasurementPinStatus(false));
    } else {
      dispatch(setMeasurementPinStatus(false));
      dispatch(setSelectedMeasurementPinReduxStateAction(e.target.value));
      dispatch(setViewMeasurementReduxStateAction(true));
    }
  };

  const showDiscardBox2 = () => {
    return (
      <Modal
        open={discardPopUp2}
        onClose={() => setDiscardPopUp2(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Discard_changes")}?</p>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button onClick={() => rerenderData2()} className="primary">
                {t("Yes")}
              </button>
              <button onClick={() => setDiscardPopUp2(false)}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  var updateEzLocator = async () => {
    if (!checkEzLocator()[0]?.LatestEzLocatorPinHistory) {
      setEZlocatorModal(true);
      return;
    }
    try {
      let response = await API_CALLS.updateEzLocatorPins(
        localStorage.getItem("recentSite"),
        localStorage.getItem("courseId"),
        dateToDisplayFormat(
          carPinPlacementDataUpdated,
          "YYYY-MM-DDTHH:mm:ss"
        ).split("T")[0],
        headersConfigData
      );
      let jsonResponse = await response.json();
      dispatch(carPinPlacementStateDataAction(jsonResponse));
      dispatch(carPinPlacementStateStatusAction(API_STATUSES.SUCCESS));

      const temp = updatedCourses?.map((data) => {
        if (data?.Number === courseNumber) {
          return {
            ...data,
            updatedEzLocator: true,
            CreationDateInUtc: jsonResponse?.UpdatedPins?.CreationDateInUtc,
          };
        } else {
          return data;
        }
      });

      setUpdatedCourses(temp);
    } catch (err) {
      dispatch(carPinPlacementStateStatusAction(err));
    }
  };

  if (greensWithPinPlacementStateStatus === "request") {
    return <Loader />;
  }

  const dateFormats = [
    //currently doesn't support time only sorting (without a date)
    "MM/DD/YYYY",
    "DD/MM/YYYY",
    "YYYY-MM-DD",
    "DD-MMM-YYYY",
    "YYYY-MM-DDTHH:mm:ss",
    "YYYY-MM-DDTHH:mm:ss.SSS",
    "YYYY-MM-DDTHH:mm:ss.SSSZ",
  ];

  const dateToDisplayFormat = (time, format) => {
    if (format === undefined) format = "lll";
    let timeVar = moment(time, dateFormats);
    return timeVar.isAfter("1901-01-01") ? timeVar.format(format) : "";
  };

  const localMomentFromUtcTime = (utcTime, format) => {
    // use default format if not provided.
    // NOTE:  format dbDateFormatUTC specified in cfmConstants would make a circular reference.
    // NOTE:  Adding Z to specify the time zone specifically on the default time format serialized by the server.
    if (!format) {
      format = "YYYY-MM-DDTHH:mm:ssZ";
      utcTime += "Z";
    }

    const time = moment(utcTime, format);
    return time;
  };

  const utcToDisplayFormat = (time, format) => {
    // If null or undefined, return empty string
    if (!time) return "";

    const timeVar = localMomentFromUtcTime(time);
    if (format === undefined) format = "lll";
    return timeVar.isAfter("1901-01-01") ? timeVar.format(format) : "";
  };

  const checkEzLocator = () => {
    const tempData = siteSettingsData?.Courses.filter(
      (item) => item.Number === courseNumber
    );

    return tempData;
  };

  return (!getFeatureSetOption(siteSettingsData && siteSettingsData?.Features, getFeaturesList().golfer_experience) && 
  (<>       
        <Container>
          <Header className={ezLocatorState && "ezLocator-header"}>
            {ezLocatorState ? (
              <div className="ezlocator-section">
                <Tooltip title={"Pull latest from Ezlocator"} arrow>
                  <button
                    className="ezlocator-button"
                    onClick={() => updateEzLocator()}
                  >
                    Pull latest from
                    <img
                      src={EzlocatorButtonIcon}
                      alt="EzlocatorButtonIcon"
                      className="ezIcon-btn"
                    />
                  </button>
                </Tooltip>
                {checkEzLocator()[0]?.LatestEzLocatorPinHistory ? (
                  <p className="pinsheet-time">
                    Pinsheet for&nbsp;'
                    {
                      dateToDisplayFormat(
                        updatedCourses?.find(
                          (item) => item?.Number === courseNumber
                        )?.updatedEzLocator
                          ? updatedCourses?.find(
                              (item) => item?.Number === courseNumber
                            )?.CreationDateInUtc
                          : checkEzLocator()[0]?.LatestEzLocatorPinHistory
                              ?.PinsApiExecutedUtc,
                        "YYYY-MM-DDTHH:mm:ss"
                      ).split("T")[0]
                    }
                    '&nbsp;was pulled from ezLocator system on &nbsp;
                    {utcToDisplayFormat(
                      updatedCourses?.find(
                        (item) => item?.Number === courseNumber
                      )?.updatedEzLocator
                        ? updatedCourses?.find(
                            (item) => item?.Number === courseNumber
                          )?.CreationDateInUtc
                        : checkEzLocator()[0]?.LatestEzLocatorPinHistory
                            ?.PinsApiExecutedUtc
                    )}
                    &nbsp;(
                    {updatedCourses?.find(
                      (item) => item?.Number === courseNumber
                    )?.updatedEzLocator
                      ? utcToDisplayFormat(
                          updatedCourses?.find(
                            (item) => item?.Number === courseNumber
                          )?.updatedEzLocator
                            ? updatedCourses?.find(
                                (item) => item?.Number === courseNumber
                              )?.CreationDateInUtc
                            : checkEzLocator()[0]?.LatestEzLocatorPinHistory
                                ?.PinsApiExecutedUtc,
                          "YYYY-MM-DDTHH:mm:ss"
                        )
                      : dateToDisplayFormat(
                          updatedCourses?.find(
                            (item) => item?.Number === courseNumber
                          )?.updatedEzLocator
                            ? updatedCourses?.find(
                                (item) => item?.Number === courseNumber
                              )?.CreationDateInUtc
                            : checkEzLocator()[0]?.LatestEzLocatorPinHistory
                                ?.PinsApiExecutedUtc,
                          "YYYY-MM-DDTHH:mm:ss"
                        )}
                    Z UTC)
                  </p>
                ) : (
                  <p className="pinsheet-time">
                    Pin information has not been pulled from ezLocator.
                  </p>
                )}
                <a
                  className="link-div"
                  rel="noopener noreferrer"
                  href="https://www.pinsheet.com/"
                  target="_blank"
                >
                  <img src={EzlocatorIcon} alt="EzlocatorIcon" />
                  <EzlocatorLinkIcon />
                </a>
              </div>
            ) : (             
              <div className="left-section">
                <div>
                  <div>
                    <button
                      id="gridButton"
                      className={
                        viewGridsReduxState ? "active sqr-btn" : "sqr-btn"
                      }
                      onClick={handleGrids}
                    >
                      <GridIcon /> <span className="display">{t("Grid")}</span>
                    </button>
                  </div>
                  <div
                    className={
                      viewMeasurementReduxState
                        ? "internal-div active"
                        : "internal-div"
                    }
                  >
                    <button
                      onClick={handleClick}
                      className={
                        viewMeasurementReduxState ? "button active" : "button"
                      }
                    >
                      <MeasurementIcon color="var(--input-background)" />
                      <span className="display">{t("Measurement")}</span>
                    </button>
                    <div>
                      <FormControl>
                        <InputLabel htmlFor="grouped-select">
                          Grouping
                        </InputLabel>
                        <Select
                          defaultValue=""
                          id="grouped-select"
                          label="Grouping"
                          onChange={handleMeasurement}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <ListSubheader>
                            {t("Daily_Pin_Rotations")}
                          </ListSubheader>
                          {dailyRotationSets &&
                          dailyRotationSets?.value &&
                          dailyRotationSets?.value.length !== 0 ? (
                            dailyRotationSets?.value.map((item, index) => (
                              <MenuItem
                                key={`${index}+${uuid()}`}
                                value={item?.Marker}
                              >
                                {t("Daily_Pin_Rotation")} {index + 1}
                                {item?.Marker ===
                                selectedMeasurementPinReduxState?.toString() ? (
                                  <DoneIcon />
                                ) : (
                                  ""
                                )}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem value=""></MenuItem>
                          )}
                          <Divider />
                          <ListSubheader>
                            {t("Special_Event_Pins")}
                          </ListSubheader>
                          {specialRotationSets &&
                          specialRotationSets?.length !== 0 ? (
                            specialRotationSets?.map((item, index) => (
                              <MenuItem
                                key={`${index}+${uuid()}`}
                                value={item?.Marker}
                              >
                                {item?.DisplayName}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem value=""></MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  {viewMeasurementReduxState ? (
                    <div className="open-menu">
                      <div>
                        <div className="side-change">
                          <button
                            className={
                              viewMeasureFromReduxState === "front-closest"
                                ? "selected"
                                : ""
                            }
                            onClick={() => getPinsDistance("front-closest")}
                          >
                            <img src={FrontClosest} alt="icon" />
                            <span className="display">
                              {t("Front_-_Closest_Side")}
                            </span>
                          </button>
                          <button
                            className={
                              viewMeasureFromReduxState === "closest"
                                ? "selected"
                                : ""
                            }
                            onClick={() => getPinsDistance("closest")}
                          >
                            <img src={Closest} alt="icon" />
                            <span className="display">{t("Closest")}</span>
                          </button>
                          <button
                            className={
                              viewMeasureFromReduxState === "front-left"
                                ? "selected"
                                : ""
                            }
                            onClick={() => getPinsDistance("front-left")}
                          >
                            <img src={FrontLeft} alt="icon" />
                            <span className="display">{t("Front-Left")}</span>
                          </button>
                          <button
                            className={
                              viewMeasureFromReduxState === "center"
                                ? "selected"
                                : ""
                            }
                            onClick={() => getPinsDistance("center")}
                          >
                            <img src={Center} alt="icon" />
                            <span className="display">{t("Center")}</span>
                          </button>
                        </div>
                      </div>
                      <div>
                        <div className="side-change">
                          <button
                            className={
                              viewDistanceYardsReduxState ? "selected" : ""
                            }
                            onClick={() => calculateDimension("yards")}
                          >
                            <span className="bold">Y</span>{" "}
                            <span className="display">&nbsp;{t("Yards")}</span>
                          </button>
                          <button
                            className={
                              viewDistanceYardsReduxState ? "" : "selected"
                            }
                            onClick={() => calculateDimension("meters")}
                          >
                            <span className="bold">M</span>
                            <span className="display">&nbsp;{t("Meters")}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <button
                      className={
                        activeOnlyReduxState ? "active sqr-btn" : "sqr-btn"
                      }
                      onClick={showActivePins}
                    >
                      <ActiveCircleIcon color="#fff" />
                      <span className="display"> {t("Active_Only")} </span>
                    </button>
                  )}
                </div>
                <div>
                  <div
                    className="active-rotation"
                    style={{ cursor: "pointer" }}
                  >
                    <p className="label-text">{t("Set_Active_Rotation")}</p>
                    <FormControl>
                      <Select
                        disabled={
                          isUserBasic(getUserRole && getUserRole?.Role) ||
                          isUserReadOnly(getUserRole && getUserRole?.Role)
                        }
                        value={rotationValues}
                        onChange={handleRotations}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {dailyRotationSets &&
                        dailyRotationSets?.value &&
                        dailyRotationSets?.value.length !== 0 ? (
                          <ListSubheader>
                            {t("Daily_Pin_Rotations")}
                          </ListSubheader>
                        ) : (
                          <></>
                        )}
                        {dailyRotationSets &&
                        dailyRotationSets?.value &&
                        dailyRotationSets?.value.length !== 0 ? (
                          dailyRotationSets?.value.map((item, index) => (
                            <MenuItem
                              key={`${index}+${uuid()}`}
                              value={`${item?.Marker},${item?.DisplayName}`}
                            >
                              {t("Daily_Pin_Rotation")} {index + 1}
                              &ensp;
                              {item?.Marker ===
                              selectedMeasurementPinBackupReduxState?.toString() ? (
                                <Chip icon={<ActiveText />} />
                              ) : (
                                ""
                              )}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem></MenuItem>
                        )}
                        <Divider />
                        {specialRotationSets &&
                        specialRotationSets?.length !== 0 ? (
                          <ListSubheader>
                            {t("Special_Event_Pins")}
                          </ListSubheader>
                        ) : (
                          <></>
                        )}
                        {specialRotationSets &&
                        specialRotationSets?.length !== 0 ? (
                          specialRotationSets?.map((item, index) => (
                            <MenuItem
                              key={`${index}+${uuid()}`}
                              value={item?.Marker}
                            >
                              {item?.DisplayName}
                              &ensp;
                              {item?.Marker ===
                              String(selectedMeasurementPinReduxState) ? (
                                <Chip label="Active" />
                              ) : (
                                ""
                              )}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem></MenuItem>
                        )}
                        <Divider />
                        <ListSubheader>{t("Center_of_Green")}</ListSubheader>
                        <MenuItem value="cog">
                          {t("Center_of_Green")}
                          {selectedMeasurementPinBackupReduxState === "cog" ? (
                            <Chip icon={<ActiveText />} />
                          ) : (
                            <></>
                          )}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    className="print active-rotation for-web"
                    style={{ cursor: "pointer" }}
                  >
                    <p className="label-text">{t("Print_Pin_Sheet")}</p>
                    <FormControl>
                      <Select
                        value=""
                        onChange={handlePrintPreview}
                        IconComponent={KeyboardArrowDownIcon}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        <MenuItem value="color">{t("Color")}</MenuItem>
                        <MenuItem value="black">{t("Black_&_White")}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <button
                    className={
                      pinsEditModeReduxState ? "active sqr-btn" : "sqr-btn"
                    }
                    style={{
                      cursor: PINS_GLOBAL_STATE.setdisabledEditButton.get()
                        ? "context-menu"
                        : "pointer",
                    }}
                    disabled={
                      PINS_GLOBAL_STATE.setdisabledEditButton.get() ||
                      isUserBasic(getUserRole && getUserRole?.Role) ||
                      isUserReadOnly(getUserRole && getUserRole?.Role)
                    }
                    onClick={() =>
                      dispatch(
                        setPinsEditModeReduxStateAction(!pinsEditModeReduxState)
                      )
                    }
                  >
                    <EditIcon
                      color="var(--theme-text)"
                      style={{
                        cursor: PINS_GLOBAL_STATE.setdisabledEditButton.get()
                          ? "context-menu"
                          : "pointer",
                      }}
                    />
                    <span className="display">{t("Edit")}</span>
                  </button>
                </div>
                <ButtonHandlerComponent
                  setDiscardPopUp={setDiscardPopUp}
                  discardPopUp={discardPopUp}
                  saveCourseRotationSets={saveCourseRotationSets}
                />
                <RefreshBtn>
                  <CircleBtn onClick={refreshData} className="mobBtn">
                    <RefreshIcon color="var(--theme-text)" />
                    <span className="display">{t("Refresh")}</span>{" "}
                  </CircleBtn>
                </RefreshBtn>
                {
                (isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role))?
                <div>
                <Tooltip title={t("View_admin_data")} arrow>
                <button
                className={
                  pinsAdminModeReduxState ? "activeAdmin sqr-btn" : "admin sqr-btn"
                }
                onClick={() =>
                  dispatch(
                    setPinsAdminModeReduxStateAction(!pinsAdminModeReduxState)
                  )
                }
                >
                <AdminIcon color={pinsAdminModeReduxState ? "var(--theme-text)" : "var(--text-secondary)"}></AdminIcon>
                <span className="display">{t("Admin_Short")}</span>
                </button>
                </Tooltip>
                </div>
              :<></>}
              </div>
            )}
          </Header>

          <BodySection>
            {showPopupBox()}
            {showDiscardBox()}
            {showDiscardBox2()}
            <div
              id="pinDistanceToolTip"
              style={{ position: "absolute", visibility: "hidden" }}
            >
              Yards from Left
            </div>
            <div className="container">
              
              <div className="ground-select">
              <div>
                {pinsAdminModeReduxState && carPinPlacementStateData.CourseRotationSets?.Courses && carPinPlacementStateData.CourseRotationSets?.Courses?.filter(d=> d.CourseNumber === courseNumber).length <=0 ? <div  style={{ color: "#c09853", backgroundColor: "#fcf8e3" }}>&nbsp;Warning :&nbsp; No car pin placements entry available for this course.  Cars should be showing distances to the Center of Green.</div>:<></>}
                {pinsAdminModeReduxState?(<div>&nbsp;  Car pins were published by Admin service on &nbsp; {moment.utc((carPinPlacementDataUpdated)).utcOffset(-(siteSettingsData && siteSettingsData?.TimeZoneOffset)).format("DD-MMM-YYYY, h:mm a")} ({
                carPinPlacementDataUpdated
                } UTC)</div>):(<div></div>)}
              </div>
                <FormControl>
                  <Select
                    native
                    labelId="demo-controlled-open-select-label"
                    id="demo-controlled-open-select"
                    variant="outlined"
                    value={coursesData.length < courseNumber? courseNumberData : courseNumber}
                    onChange={handleCourseName}
                  >
                    {coursesData && coursesData.length !== 0 ? (
                      coursesData.map((item, index) => (
                        <option
                          value={item?.Number}
                          key={`coursesData_${index}`}
                        >
                          {item?.Name}
                        </option>
                      ))
                    ) : (
                      <option value=""></option>
                    )}
                  </Select>
                </FormControl>
              </div>
              <div
                className="box-wrapper print-source"
                id="printableDiv"
                ref={colorPrintComponentRef}
              >
                <div className="print-box">
                  <span className="xl">{t("Pin_Sheet_for")}</span>
                  <span id="courseInfo">
                    &nbsp;{siteName ? siteName : ""}&nbsp;[
                    {siteId.get() ? siteId.get() : ""}] -{" "}
                    {courseName ? courseName : ""}
                  </span>{" "}
                  <br />
                  <p>{rotationNameValue ? rotationNameValue : ""}</p>
                </div>
                <ul className="inner-box">
                  {greensWithPinPlacementStateData &&
                  greensWithPinPlacementStateData?.ApproachViews &&
                  greensWithPinPlacementStateData?.ApproachViews.length !==
                    0 ? (
                    greensWithPinPlacementStateData?.ApproachViews.map(
                      (hole) => (
                        <Canvas
                          key={uuid()}
                          carPinPlacementStateData={
                          carPinPlacementStateData?.CourseRotationSets
                          }
                          holeData={hole}
                          greensDescriptions={greensWithPinPlacementStateData}
                          childFunc={childFunc}
                          measurementState={viewMeasurementReduxState}
                        />
                      )
                    )
                  ) : (
                    <h2>No Data Available For This Site</h2>
                  )}
                </ul>
                <div style={{ display: "none" }}>
                  <PinSheetComponent printComponentRef={printComponentRef} />
                </div>
              </div>
            </div>
            <Modal
              open={EZlocatorModal}
              onClose={() => setEZlocatorModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <PopUpContainer>
                  <h2>Visage</h2>
                  <p>Failure occured while updating ezLocator pin locations.</p>
                  <div className="action-btn" style={{ marginTop: 20 }}>
                    <button
                      onClick={() => setEZlocatorModal(false)}
                      className="primary"
                    >
                      {t("Ok")}
                    </button>
                  </div>
                </PopUpContainer>
              </Box>
            </Modal>
          </BodySection>
        </Container>
      </>
    )
  );
});
